/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/function-component-definition */
import React, { useState, useEffect } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { AppBar, Divider } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import Toolbar from '@material-ui/core/Toolbar'
import CloseIcon from '@material-ui/icons/Close'

import { useStyles } from './styles'

const OPERACIONES = [
  'UNION',
  'INTERSECCION',
  'DIFERENCIA',
  'DIFERENCIA_SIMETRICA',
]

export default function FormDialog(props) {
  const { onChangeSqlStatus, onSaveCon } = props
  const [value, setValue] = useState([])
  const classes = useStyles()

  const fixedOptions =
    props.tags[props.tags.findIndex((value) => value?.tableData?.checked)]

  const onSave = () => {
    onSaveCon(value)
  }

  useEffect(() => {
    setValue('')
  }, [props.open])

  return (
    <div>
      <Dialog open={props.open} aria-labelledby="form-dialog-title">
        <AppBar centered="true" className={classes.appBar}>
          <Toolbar>
            <IconButton
              onClick={() => onChangeSqlStatus(1)}
              edge="start"
              color="inherit"
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogTitle id="form-dialog-title">
          Seleccione el conjunto a operar
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            1. Los tags generados por operacion no se actualizan automaticamente
            si el tag origen es modificado, en caso de que el tag origen sea
            modificado se requiere volver a ejecutar la operacion entre tags.
            <br />
            2. Los tags que no se les haya calculado previamente el numero de
            usuarios no aparecerá en la lista de tags seleccionables para
            operar.
            <br />
            3. Un tag generado por operacion funciona bajo la metodología de
            query por lo tanto no estarán disponibles las opciones de filtrado
            de una tag normal. <Divider />
            <p>
              <br />
              <strong>Tag: </strong> {value[0]?.tag}
              <br />
              <strong>Operación:</strong> {value[value?.length - 1]?.operacion}
              <br />
              <strong>Conjunto:</strong> {value[1]?.tag} - {value[2]?.tag}
              <br />
            </p>
            <Divider />
          </DialogContentText>
          <br />
          <Autocomplete
            multiple
            // filterSelectedOptions
            id="tags-standard"
            // onChange={(event, newValue) => setValue(newValue)}
            options={props.tags}
            limitTags={3}
            getOptionLabel={(option) => option.tag}
            onChange={(event, newValue) => {
              setValue([fixedOptions, ...newValue])
            }}
            getOptionDisabled={(option) =>
              option?.tableData.checked === fixedOptions?.tableData.checked ||
              value.length >= 3
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Seleccione los tags a operar"
                placeholder="Tags"
              />
            )}
          />
          <br />
          <Autocomplete
            id="tags-standard"
            options={OPERACIONES}
            onChange={(event, newValue) => {
              setValue((prev) => [...prev, { operacion: newValue }])
            }}
            getOptionDisabled={() => value.length === 0}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Tipo de operación"
                placeholder="Operación"
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onSave}
            disabled={value.length < 4}
            variant="contained"
            color="primary"
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
